export default __webpack_public_path__ + "static/media/pc_step_2_Hk.9ef3717e.png";